export enum PaymentMethodEnum {
  CASH,  
  ELECTRONIC_TRANSFER,
  BANK,
  PETTY_CASH,
  OTHER
}
